import React, { useEffect, useState } from "react";
import { Line, Doughnut, Bar } from "react-chartjs-2";
import {
   Chart as ChartJS,
   CategoryScale,
   LinearScale,
   PointElement,
   LineElement,
   ArcElement,
   BarElement,
   Tooltip,
   Legend,
} from "chart.js";
import { tripDashboardReportApiCall } from "../../Api/api";
import "./dashboard.css";

ChartJS.register(
   CategoryScale,
   LinearScale,
   PointElement,
   LineElement,
   ArcElement,
   BarElement,
   Tooltip,
   Legend
);

const Body = () => {
   const [reportData, setReportData] = useState(null);
   const todayTrips =
      Number(reportData?.dispatched_today_trips || 0) +
      Number(reportData?.dispatched_today_adhoc_trips || 0);
   const openTrips = Number(reportData?.open_trips || 0);
   const pendingTrips = Number(reportData?.pending_trips || 0);
   const pendingAdhoc = Number(reportData?.pending_adhoc_lanes || 0);
   const totalTrips = todayTrips + openTrips + pendingTrips + pendingAdhoc;

   const getDashboardReport = async () => {
      try {
         const res = await tripDashboardReportApiCall();
         setReportData(res?.data);
      } catch (error) {}
   };

   useEffect(() => {
      getDashboardReport();
   }, []);

   const statCards = [
      {
         label: "Trip Approval Pending",
         value: pendingTrips,
         icon: "fas fa-truck-loading",
         colorClass: "dashboard-stat-blue",
         href: "/trip/contractual/view/?review_status=pending",
      },
      {
         label: "Today's Dispatched Trip",
         value: todayTrips,
         icon: "fas fa-map-marker-alt",
         colorClass: "dashboard-stat-green",
         href: "/trip/contractual/view/?trip_status=dispatched",
      },
      {
         label: "Open Trips",
         value: openTrips,
         icon: "fas fa-paper-plane",
         colorClass: "dashboard-stat-yellow",
         href: "/trip/contractual/view/?trip_status=open",
      },
      {
         label: "Adhoc Lane Pending",
         value: pendingAdhoc,
         icon: "fas fa-users",
         colorClass: "dashboard-stat-purple",
         href: "/manager/adhoc/lane/view",
      },
   ];

   const lineData = {
      labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      datasets: [
         {
            label: "Trips",
            data: [
               Math.max(1, Math.floor(totalTrips * 0.15)),
               Math.max(2, Math.floor(totalTrips * 0.28)),
               Math.max(3, Math.floor(totalTrips * 0.34)),
               Math.max(2, Math.floor(totalTrips * 0.26)),
               Math.max(3, Math.floor(totalTrips * 0.22)),
               Math.max(2, Math.floor(totalTrips * 0.31)),
               Math.max(1, Math.floor(totalTrips * 0.24)),
            ],
            borderColor: "#2f80ed",
            backgroundColor: "rgba(47, 128, 237, 0.1)",
            fill: true,
            tension: 0.4,
            pointRadius: 3,
         },
      ],
   };

   const doughnutData = {
      labels: ["Completed", "In Progress", "Pending", "Cancelled"],
      datasets: [
         {
            data: [
               Math.max(1, Math.floor(totalTrips * 0.45)),
               Math.max(1, Math.floor(totalTrips * 0.25)),
               Math.max(1, Math.floor(totalTrips * 0.2)),
               Math.max(1, Math.floor(totalTrips * 0.1)),
            ],
            backgroundColor: ["#22c55e", "#3b82f6", "#facc15", "#f97316"],
            borderWidth: 0,
         },
      ],
   };

   const barData = {
      labels: ["Haldia", "Tapukara", "Pune", "Bankura", "Manesar"],
      datasets: [
         {
            label: "Trips",
            data: [22, 18, 15, 12, 10],
            backgroundColor: ["#4f46e5", "#0ea5e9", "#22c55e", "#f59e0b", "#8b5cf6"],
            borderRadius: 8,
         },
      ],
   };

   const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: { legend: { display: false } },
   };

   const openTripsRows = [
      ["Ankoor Distil...", "Bankura (WB)", "Haldia", "WB78B2640", "AJIT PRASAD"],
      ["Test DW WISC...", "Pune", "Chandrakona", "WB92T1236", "Tez Vahicle"],
      ["Ankoor Distil...", "Tapukara", "Manesar", "WB78B2613", "MD SAFIQUE"],
   ];

   const unassignedRows = [
      ["WB78B2649", "MD ISMAIL KHAN", "Bankura (WB)"],
      ["NL01AK1561", "--", "Haldia"],
      ["WB98T2640", "--", "Pune"],
   ];

   const reminderRows = [
      ["WB98T1234", "Fitness", "07 Aug 2026", "Ajay Jain", "Tapukara"],
      ["NL01AK1563", "National Permit", "05 Aug 2026", "--", "Haldia"],
      ["NL01AK1805", "National Permit", "12 Aug 2026", "--", "Haldia"],
   ];

   return (
      <div>
         <section className="dashboard-v2-wrap">
            <div className="dashboard-v2-stats">
               {statCards.map((card) => (
                  <a key={card.label} href={card.href} className="dashboard-stat-link">
                     <article className={`dashboard-stat-card ${card.colorClass}`}>
                        <div>
                           <h3>{card.value}</h3>
                           <p>{card.label}</p>
                        </div>
                        <i className={card.icon} />
                     </article>
                  </a>
               ))}
            </div>

            <div className="dashboard-v2-grid">
               <article className="dashboard-panel dashboard-panel-wide">
                  <div className="dashboard-panel-head">
                     <h4>Trip Overview</h4>
                     <span>This Week</span>
                  </div>
                  <div className="dashboard-chart-box">
                     <Line data={lineData} options={chartOptions} />
                  </div>
               </article>

               <article className="dashboard-panel">
                  <div className="dashboard-panel-head">
                     <h4>Trip Status</h4>
                  </div>
                  <div className="dashboard-chart-box">
                     <Doughnut data={doughnutData} options={chartOptions} />
                  </div>
               </article>
            </div>

            <div className="dashboard-v2-grid">
               <article className="dashboard-panel dashboard-panel-wide">
                  <div className="dashboard-panel-head">
                     <h4>Current Trip (Open)</h4>
                  </div>
                  <div className="table-responsive">
                     <table className="table dashboard-v2-table mb-0">
                        <thead>
                           <tr>
                              <th>Customer</th>
                              <th>Source</th>
                              <th>Destination</th>
                              <th>Vehicle No</th>
                              <th>Driver</th>
                           </tr>
                        </thead>
                        <tbody>
                           {openTripsRows.map((row) => (
                              <tr key={row.join("-")}>
                                 {row.map((cell) => (
                                    <td key={cell}>{cell}</td>
                                 ))}
                              </tr>
                           ))}
                        </tbody>
                     </table>
                  </div>
               </article>

               <article className="dashboard-panel">
                  <div className="dashboard-panel-head">
                     <h4>Unassigned Trip Vehicles</h4>
                  </div>
                  <div className="table-responsive">
                     <table className="table dashboard-v2-table mb-0">
                        <thead>
                           <tr>
                              <th>Vehicle No</th>
                              <th>Driver</th>
                              <th>Attach Location</th>
                           </tr>
                        </thead>
                        <tbody>
                           {unassignedRows.map((row) => (
                              <tr key={row.join("-")}>
                                 {row.map((cell) => (
                                    <td key={cell}>{cell}</td>
                                 ))}
                              </tr>
                           ))}
                        </tbody>
                     </table>
                  </div>
               </article>
            </div>

            <article className="dashboard-panel">
               <div className="dashboard-panel-head">
                  <h4>Expiration Reminders</h4>
               </div>
               <div className="table-responsive">
                  <table className="table dashboard-v2-table mb-0">
                     <thead>
                        <tr>
                           <th>Vehicle No</th>
                           <th>Expiring Documents</th>
                           <th>Expiry Date</th>
                           <th>Driver</th>
                           <th>Location</th>
                        </tr>
                     </thead>
                     <tbody>
                        {reminderRows.map((row) => (
                           <tr key={row.join("-")}>
                              <td>{row[0]}</td>
                              <td>
                                 <span className="dashboard-badge">{row[1]}</span>
                              </td>
                              <td>{row[2]}</td>
                              <td>{row[3]}</td>
                              <td>{row[4]}</td>
                           </tr>
                        ))}
                     </tbody>
                  </table>
               </div>
            </article>

            <div className="dashboard-v2-bottom">
               <article className="dashboard-panel">
                  <div className="dashboard-panel-head">
                     <h4>Top Locations</h4>
                  </div>
                  <div className="dashboard-chart-box dashboard-chart-small">
                     <Bar data={barData} options={chartOptions} />
                  </div>
               </article>

               <article className="dashboard-panel">
                  <div className="dashboard-panel-head">
                     <h4>Recent Activities</h4>
                  </div>
                  <ul className="dashboard-activity-list">
                     <li>Trip WB78B2640 completed</li>
                     <li>New vehicle NL01AK1551 added</li>
                     <li>Driver Ajay Jain assigned</li>
                     <li>Permit expired for WB98Z1234</li>
                  </ul>
               </article>
            </div>
         </section>
      </div>
   );
};

export default Body;
